import { map } from 'lodash';
import * as moment from 'moment';
import { AttendeesList } from './submit-attendeesList-model';

export class ScheduleMeetingRequestModel {
    parentSk: string;
    referralId: string;
    personSk: string;
    formJson: string;
    meetingType: string;
    ///
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    selectedRecipient: string;
    recipientEmailAddress: string;
    recipientPhoneNumber: string;
    meetingStreetAddress1: string;
    meetingStreetAddress2: string;
    meetingFloorRoom: string;
    meetingCity: string;
    meetingState: string;
    meetingZip: string;
    meetingDate: Date;
    meetingStartTime: Date | string;
    meetingEndTime: Date | string;
    specialinstructions: string;
    translationLanguage: number;
    student: Student;
    parent: Parent;
    generalEducationTeacher: GeneralEducationTeacher;
    schoolSocialWorker: SchoolSocialWorker;
    schoolPsychologist: SchoolPsychologist;
    relatedServiceProvider: RelatedServiceProvider;
    districtRepresentative: DistrictRepresentative;
    principal: Principal;
    teacher: Teacher;
    specialEducationTeacher: SpecialEducationTeacher;
    postalMail: boolean;
    electronicMail: boolean;
    parentPortal: boolean;
    attendee: AttendeesList[];
    additionalInfo: string;
    requiredAttendees: [];
    optionalAttendees: [];
    assessmentsList: [];

    meetingDetailsDTOtranslationLanguage: number;
    constructor(data: ScheduleMeetingRequestModel) {
        this.parentSk = data.parentSk;
        this.referralId = data.referralId;
        this.personSk = data.personSk;
        this.formJson = data.formJson;
        this.contactName = data?.contactName ?? '';
        this.contactPhone = data?.contactPhone;
        this.contactEmail = data?.contactEmail ?? '';
        this.selectedRecipient = data?.selectedRecipient;
        this.recipientPhoneNumber = data?.recipientPhoneNumber;
        this.meetingStreetAddress1 = data?.meetingStreetAddress1 ?? '';
        this.meetingStreetAddress2 = data?.meetingStreetAddress2 ?? '';
        this.meetingFloorRoom = data?.meetingFloorRoom ?? '';
        this.meetingCity = data?.meetingCity;
        this.meetingState = data?.meetingState;
        this.meetingZip = data?.meetingZip;
        this.meetingDate = data?.meetingStartTime ? moment(data?.meetingStartTime).toDate() : undefined;
        this.meetingStartTime = data?.meetingStartTime !== undefined ? new Date(data?.meetingStartTime) : undefined;
        this.meetingEndTime = data?.meetingEndTime !== undefined ? new Date(data?.meetingEndTime) : undefined;
        this.student = new Student(data?.student);
        this.parent = new Parent(data?.parent);
        this.student = new Student(data?.student);
        this.generalEducationTeacher = new GeneralEducationTeacher(data?.generalEducationTeacher);
        this.specialEducationTeacher = new SpecialEducationTeacher(data?.specialEducationTeacher);
        this.schoolSocialWorker = new SchoolSocialWorker(data?.schoolSocialWorker);
        this.schoolPsychologist = new SchoolPsychologist(data?.schoolPsychologist);
        this.relatedServiceProvider = new RelatedServiceProvider(data?.relatedServiceProvider);
        this.districtRepresentative = new DistrictRepresentative(data?.districtRepresentative);
        this.principal = new Principal(data?.principal);
        this.teacher = new Teacher(data?.teacher);
        this.translationLanguage = data?.meetingDetailsDTOtranslationLanguage;
        this.specialinstructions = data?.specialinstructions;
        this.translationLanguage = data?.translationLanguage;
        this.postalMail = data?.postalMail;
        this.electronicMail = data?.electronicMail;
        this.parentPortal = data?.parentPortal;
        this.attendee = map(data?.attendee, (row: AttendeesList) => new AttendeesList(row));
        this.additionalInfo = data?.additionalInfo;
        this.requiredAttendees = data?.requiredAttendees;
        this.optionalAttendees = data?.optionalAttendees;
        this.assessmentsList = data?.assessmentsList;
    }
    get id(): string {
        return this.parentSk
    }
}

export class Student {
    studentName: string;
    studentEmail: string;
    constructor(data: Student) {
        this.studentName = data?.studentName;
        this.studentEmail = data?.studentEmail ?? '';
    }

}


export class Parent {
    parentName: string;
    parentEmail: string;
    constructor(data: Parent) {
        this.parentName = data?.parentName;
        this.parentEmail = data?.parentEmail ?? '';
    }
}

export class GeneralEducationTeacher {
    generalEducationTeacherName: string;
    generalEducationTeacherEmail: string;
    constructor(data: GeneralEducationTeacher) {
        this.generalEducationTeacherName = data?.generalEducationTeacherName;
        this.generalEducationTeacherEmail = data?.generalEducationTeacherEmail ?? '';
    }
}

export class SpecialEducationTeacher {
    specialEducationTeacherName: string;
    specialEducationTeacherEmail: string;
    constructor(data: SpecialEducationTeacher) {
        this.specialEducationTeacherName = data?.specialEducationTeacherName;
        this.specialEducationTeacherEmail = data?.specialEducationTeacherEmail ?? '';
    }
}

export class SchoolSocialWorker {
    schoolSocialWorkerName: string;
    schoolSocialWorkerEmail: string;
    constructor(data: SchoolSocialWorker) {
        this.schoolSocialWorkerName = data?.schoolSocialWorkerName;
        this.schoolSocialWorkerEmail = data?.schoolSocialWorkerEmail ?? '';
    }
}

export class SchoolPsychologist {
    schoolPsychologistName: string;
    schoolPsychologistEmail: string;
    constructor(data: SchoolPsychologist) {
        this.schoolPsychologistName = data?.schoolPsychologistName;
        this.schoolPsychologistEmail = data?.schoolPsychologistEmail ?? '';
    }
}
export class RelatedServiceProvider {
    relatedServiceProviderName: string;
    relatedServiceProviderEmail: string;
    constructor(data: RelatedServiceProvider) {
        this.relatedServiceProviderName = data?.relatedServiceProviderName;
        this.relatedServiceProviderEmail = data?.relatedServiceProviderEmail ?? '';
    }
}

export class DistrictRepresentative {
    districtRepresentativerName: string;
    districtRepresentativerEmail: string;
    constructor(data: DistrictRepresentative) {
        this.districtRepresentativerName = data?.districtRepresentativerName;
        this.districtRepresentativerEmail = data?.districtRepresentativerEmail ?? '';
    }
}

export class Principal {
    principalName: string;
    principalEmail: string;
    constructor(data: Principal) {
        this.principalName = data?.principalName;
        this.principalEmail = data?.principalEmail ?? '';
    }
}

export class Teacher {
    teacherName: string;
    teacherEmail: string;
    constructor(data: Teacher) {
        this.teacherName = data?.teacherName;
        this.teacherEmail = data?.teacherEmail ?? '';
    }
}